export const ROLE_USER = require('./ROLE_USER.constant');